import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { fetchUser } from '@/vuex/modules/auth/auth.utils';

export default {
    namespaced: true,
    state: {
        subscriptionList: [],
        sourceSub: {},
        targetSub: {},
        sourceApp: {},
        targetApp: {},
    },
    mutations: {
        setSubscriptionList (state, { list }) {
            state.subscriptionList = list;
        },
        setSourceSub (state, { sub }) {
            state.sourceSub = sub;
        },
        setTargetSub (state, { sub }) {
            state.targetSub = sub;
        },
        setSourceApp (state, { app }) {
            state.sourceApp = app;
        },
        setTargetApp (state, { app }) {
            state.targetApp = app;
        },
    },
    actions: {
        async loadSubscriptionList ({ state, commit }) {
            if (!isEmpty(state.subscriptionList)) {
                return;
            }
            const userData = await fetchUser();
            const subscriptionList = get(userData, 'subscriptions', []);
            const sortedSubscriptions = subscriptionList
                .slice()
                .sort((a, b) => {
                    const aName = a.displayName || '';
                    const bName = b.displayName || '';

                    return aName.localeCompare(bName);
                })
                .map((sub) => {
                    const purchasedProductLines = get(sub, 'productLines', [])
                        .filter((pl) => pl.purchased)
                        .map((pl) => pl.displayName);
                    const icon =
                        purchasedProductLines.includes('Adopt') || purchasedProductLines.includes('Adopt End User')
                            ? { type: 'map' }
                            : { type: 'layers' };

                    return {
                        ...sub,
                        purchasedProductLines,
                        icon,
                    };
                });
            commit('setSubscriptionList', { list: sortedSubscriptions });
        },
    },
    getters: {
        sourceSub: (state) => state.sourceSub,
        targetSub: (state) => state.targetSub,
        sourceApp: (state) => state.sourceApp,
        targetApp: (state) => state.targetApp,
        subscriptionList: (state) => state.subscriptionList,
    },
};
